// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"sectiontitle_sectionTitle__thUSJ","buzzfeed":"sectiontitle_buzzfeed__e9z_h","buzzfeed_news":"sectiontitle_buzzfeed_news__IB1_Y"};